import Roles from '../models/Roles'

export const Modes = {
    DEV: 'dev',
    STARTED_MATCH: 'STARTED_MATCH',
    WAITING_MATCH: 'WAITING_MATCH',
    QUESTION_BET: 'QUESTION_BET',
    QUESTION_TO_ASK: 'QUESTION_TO_ASK',
    QUESTION_TO_ANSWER: 'QUESTION_TO_ANSWER',
    QUESTION_ANSWERED: 'QUESTION_ANSWERED',
    QUESTION_RESULT_RIGHT: 'QUESTION_RESULT_RIGHT',
    QUESTION_RESULT_WRONG: 'QUESTION_RESULT_WRONG',
    QUESTION_RESULT_BLACK: 'QUESTION_RESULT_BLACK',
    QUESTION_NO_POINTS: 'QUESTION_NO_POINTS',
    ENDED_MATCH: 'ENDED_MATCH',
}

const fakeChatUsers = [
    { id: 'u321', username: 'pippo' },
    { id: 'u456', username: 'pluto' },
    { id: 'u678', username: 'Gastone' }
]

const getChatMessages = (num = 3) => {
    const messages = []
    for (let i = 0; i < num; i++) {
        messages.push({
            id: 'm' + i,
            date: Date.now() - (1000 * (num - i)),
            from: fakeChatUsers[Math.floor(Math.random() * fakeChatUsers.length)],
            text: 'Messaggio numero ' + i
        })
    }
    return messages
}

const match = {
    startDate: Date.now() - 10000,
    currentQuestionIndex: 2,
    totalQuestions: 5
}

const matchEnded = {
    ...match,
    endDate: Date.now() - 3000,
}

const questionToBet = {
    id: 'q1',
    bet_date: Date.now() - 9000,
    topic: 'Sport'
}
const questionBetDone = { ...questionToBet, bet: 27 }
const questionToAnswer = {
    ...questionBetDone,
    askDate: Date.now() - 1,
    msToAnswer: 20000,
    text: 'Parole di 5 lettere che iniziano per BE e finiscono per A ',
    specs: 'Si chiedono quelle parole di cinque lettere che iniziano per BE e finiscono per A. Escludiamo diminutivi, accrescitivi, migliorativi peggiorativi acronimi e nomi propri. Le parole devono essere sul vocabolario quindi attenzione a inserire aggettivi al femminile che invece sono presenti sul vocabolario solo al maschile. ',
}
const questionAnswered = { ...questionToAnswer, answer: 'bella' }
const questionAnsweredRight = {
    ...questionAnswered,
    quote: 2,
    gain: questionAnswered.bet * 2,
    balance: 50 + questionAnswered.bet * 2
}
const questionAnsweredWrong = {
    ...questionAnswered,
    quote: 2,
    gain: 0,
    balance: 50,
}
const questionAnsweredBlack = {
    ...questionAnswered,
    quote: 0,
    gain: -25,
    balance: 25
}


const states = {
    [Modes.DEV]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.DEV], isLogged: true }
    },

    [Modes.WAITING_MATCH]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120)
    },

    [Modes.STARTED_MATCH]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_BET]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            id: 1,
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionToBet,
        },
        question_game: {
            '1 q1': {
                bet_date: Date.now() - 500
            }
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_TO_ASK]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionBetDone,
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_TO_ANSWER]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionToAnswer,
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_ANSWERED]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionAnswered,
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_RESULT_RIGHT]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionAnsweredRight,
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_RESULT_WRONG]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionAnsweredWrong,
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_RESULT_BLACK]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: questionAnsweredBlack,
        },
        currentQuestionId: 'q1',
        balance: 50,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.QUESTION_NO_POINTS]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: {
            starting_time: Date.now() - 10000
        },
        questions: {
            q1: {},
        },
        currentQuestionId: 'q1',
        balance: 0,
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    },

    [Modes.ENDED_MATCH]: {
        user: { id: 'u123', token: 't123', username: 'Player', roles: [Roles.PLAYER], isLogged: true },
        chatMessages: getChatMessages(120),
        match: { 
            starting_time: Date.now() - 10000,
            ending_time: Date.now() - 3000,
        },
        live_video_url: 'https://www.youtube.com/watch?v=hHW1oY26kxQ',
    }
}


export default (mode) => states[mode]


// WEBPACK FOOTER //
// ./src/utils/dummyState.js